export class AwsSecretsManagerRef {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "arn",
            "baseName": "arn",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsSecretsManagerRef.attributeTypeMap;
    }
    constructor() {
    }
}
